<template>
  <div class="data-view">
    <div class="data-view__title">
      <TitleBar :title="t('measurement.measurements')">
        <BfButton
          :type="ButtonType.Outlined"
          icon="/icons/52-Arrows-Diagrams/01-Arrows/arrow-left-1.svg"
          @click="previous"
        >
          {{ t('common.previous') }}
        </BfButton>
        <BfButton
          :state="
            loading
              ? ButtonState.Loading
              : measurements.length > 2
                ? ButtonState.Enabled
                : ButtonState.Disabled
          "
          :icon-position="ButtonIconPosition.Right"
          icon="/icons/52-Arrows-Diagrams/01-Arrows/arrow-right-1.svg"
          @click="next"
        >
          {{ t('common.next') }}
        </BfButton>
      </TitleBar>
    </div>

    <div class="data-view__content">
      <div v-if="error">
        <p>{{ t('completion.updateXY.error') }}</p>
      </div>
      <MeasurementOverview v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useBikeStore } from '@/store/bikeStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useUserStore } from '@/store/userStore'
import { storeToRefs } from 'pinia'
import {
  ButtonType,
  ButtonState,
  BfButton,
  ButtonIconPosition,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import TitleBar from '@/components/layout/TitleBar.vue'
import MeasurementOverview from '@/components/measurement/MeasurementOverview.vue'

const { t } = useI18n()
const bikeStore = useBikeStore()
const measurementStore = useMeasurementStore()
const userStore = useUserStore()
const { measurements } = storeToRefs(measurementStore)
const { customerId, dealerId, sessionId } = storeToRefs(userStore)
const { updateXY } = bikeStore

const router = useRouter()

const loading = ref(false)
const error = ref(false)

const previous = () => {
  router.push({ name: 'analysis' })
}

const next = () => {
  const finalMeasurement = JSON.parse(
    JSON.stringify(measurements.value[measurements.value.length - 2]),
  )

  loading.value = true

  if (finalMeasurement.handlebar) {
    finalMeasurement.handlebar.x = Math.abs(finalMeasurement.handlebar.x)
    finalMeasurement.handlebar.y = Math.abs(finalMeasurement.handlebar.y)
  }
  if (finalMeasurement.saddle) {
    finalMeasurement.saddle.x = Math.abs(finalMeasurement.saddle.x)
    finalMeasurement.saddle.y = Math.abs(finalMeasurement.saddle.y)
  }

  updateXY(
    customerId.value,
    dealerId.value,
    sessionId.value,
    finalMeasurement,
    true,
  ).then((response) => {
    loading.value = false

    if (response?.Succeeded) {
      router.push({ name: 'completion' })
    } else {
      error.value = true
    }
  })
}
</script>

<style lang="scss">
.data-view {
  display: flex;
  flex-direction: column;
  background-color: #fbfbfb;
  height: 100%;

  &__title {
    padding: 2.4rem;
  }

  &__content {
    overflow-y: auto;
    flex: 1;
    padding-bottom: 2.4rem;
  }
}
</style>
